import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, NgModule, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureSetData } from '../../interfaces/data-analytics';
import { LwProductService } from '../../lw-product/lw-product.service';
import { IconsService } from '../../services/icons.service';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { LdsUserService } from '../../services/lds-user.service';

@Component({
    selector: 'lds-energy-monitor-card',
    templateUrl: './energy-monitor-card.component.html',
    styleUrls: ['./energy-monitor-card.component.css'],
    standalone: false
})

export class EnergyMonitorCardComponent implements OnInit {
	@Input() data: FeatureSetData;
	@Input() deviceType: String;
	@Input() index: String;

	icon: String;
	features: Object[] = [];
	type: String;
	margin: String;
	aside: String = 'hover-text hide';
	container_class = 'my-field';
	octopusData;
	serialNumber: string;
	mpan: string;
	apiKey: string;
	
	constructor(private lwProductService: LwProductService, private router: Router, public icons: IconsService, private eventBus: LdsEventBusService, private user: LdsUserService) {
	}

	changeStyle($event) {
		if (this.data.last_updated) {
			this.aside = $event.type === 'mouseover' ? 'hover-text show' : 'hover-text';
		}
	}

	ngOnInit() {
		this.octopusData = this.user.getOctopusData();
		if (!this.data.last_updated) {
			this.container_class = 'my-field disabled';
		}
		this.icon = this.data.icon;
		this.margin = this.lwProductService.findFixedMargin(this.data.icon);
		let featureArray = this.lwProductService.findAvailableFeature(this.data.productCode);
		for (let i = 0; i < featureArray.length; i++) {
			this.features.push({
				name: featureArray[i],
				icon: this.lwProductService.findFeatureMiniIcons(featureArray[i])
			});
		}
		this.type = this.lwProductService.findType(this.data.productCode);
	}

	clicked() {
		console.log('EnergyMonitorCardComponent - clicked - data: ', this.data);
		this.router.navigate(['/data-studio/energy-monitor/' + this.data.groupId]);
	}

	onSubmit(serialNumber, mpan, apiKey) {
		this.user.setOctopusData(serialNumber, mpan, apiKey);
		this.octopusData = {
			serialNumber,
			mpan,
			apiKey
		};
	}
}
